(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1531],{

/***/ 14385:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/not-exists-content",
      function () {
        return __webpack_require__(69551);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ not_exists_content; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ./src/ui/ContentsButton/index.ts + 1 modules
var ContentsButton = __webpack_require__(27689);
// EXTERNAL MODULE: ./src/ui/Image/index.ts
var Image = __webpack_require__(71267);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-d9635043d0/0/cache/@design-system-pc-npm-5.0.16-99183adf3a-7a75a8a3de.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(80571);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(88276);
;// CONCATENATED MODULE: ./src/feat-components/error/NotExistsContent.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 160px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 120px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-bottom: 80px;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  max-width: 570px;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var NotExistsContent = function() {
    var router = (0,next_router.useRouter)();
    var returnUrl = router.query.returnUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoIconBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc.CI, {
                    variant: "CI_symbol_primary",
                    resize: true,
                    width: 121,
                    height: 30
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BangIconBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: (0,utils/* getAsset */.Nh)("/assets/icons/ic_empty_72.svg"),
                    width: "72px",
                    height: "72px",
                    alt: "errorBangIcon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                children: "존재하지 않는 컨텐츠입니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnLayout, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsButton/* default */.Z, {
                    size: "bold",
                    emphasis: "low",
                    width: "100%",
                    onClick: function() {
                        return returnUrl ? router.replace(returnUrl) : router.back();
                    },
                    children: "이전 페이지"
                })
            })
        ]
    });
};
/* harmony default export */ var error_NotExistsContent = (NotExistsContent);
var ErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotExistsContent__ErrorContainer",
    componentId: "sc-c640e716-0"
})(_templateObject());
var LogoIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotExistsContent__LogoIconBox",
    componentId: "sc-c640e716-1"
})(_templateObject1());
var BangIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotExistsContent__BangIconBox",
    componentId: "sc-c640e716-2"
})(_templateObject2());
var ErrorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotExistsContent__ErrorTitle",
    componentId: "sc-c640e716-3"
})(_templateObject3(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle2 */.rS.typography.subtitle2);
var BtnLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NotExistsContent__BtnLayout",
    componentId: "sc-c640e716-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./pages/not-exists-content.tsx



var NotExistsCotentPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_NotExistsContent, {});
};
/* harmony default export */ var not_exists_content = (NotExistsCotentPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(14385); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);